import H2GHISTORY from 'h2g-test-history/js/test-history';
import {SUTIL,TUTIL,sendAnalyticsInfo,covertSecondsToMinsSecs,applyFix,software_use_events} from 'h2g-test-results/js/util';
import {get_json_as_html,TR,is_periodic_test,getTestSettingsValue,getRouteringTestResults} from 'h2g-test-results/js/test-results';
import ui_settings from 'h2g-test-results/js/ui_settings';
import $ from 'jquery';
import async from 'async';

 var H2GDIALOG = {
  root_path:"",
  mdDialog:"",
  remote_ctrl_timer:null,
  incoming_call_timer:null,
  create_MdDialog:null,
  create_customDialog:null,
  showInputTemplate : function(inputCtrl,message) {
   H2GDIALOG.create_MdDialog(inputCtrl,message,C11N.root_path +'h2g-material/dialogs/InputDialog.html');
  },
  show_portal_results_screen:null,
  menuItemCtrl : function menuItemCtrl($scope, $mdDialog,$rootScope,message){
   $scope.controller = "showMoreInfoDialog";
   $scope.loaderImg = WTG.img("loader.svg");
   $scope.is_portal = C11N.is_portal;
   var obj={};
   obj.testName=message.testname;
   obj.component=message.component;
   message.more_btn_in_history=!C11N.is_portal && (ui_settings && ui_settings[message.testname] && ui_settings[message.testname].more_btn && ui_settings[message.testname].more_btn_in_history);
   obj.more_btn_in_history=message.more_btn_in_history || "";
   obj.moreDetails=message.more;
   obj.testTitle=message.Result_header;
   obj["eval"]=message.Result_evaluation;
   obj.showBtn=message.genericBtn;
   obj.genericBtnTxt=message.btnTxt;
   obj.testId=message.id;
   obj.notification_switch_status = true;
   obj.turned_off = false;
   function show_backup_restore() {
    if(_TDC || message.testname != "routering") return false;
    var routering_res = getRouteringTestResults();
    return (routering_res && routering_res.res_data && routering_res.res_data.type && (routering_res.res_data.type=='TR64' || routering_res.res_data.type=='UnifiedAdditional') && routering_res.result && (routering_res.result == "ok"));
   }
   function is_backup_present() {
    var routering_res = getRouteringTestResults();
    return (routering_res && routering_res.res_data && routering_res.res_data.type && (routering_res.res_data.type=='TR64' || routering_res.res_data.type=='UnifiedAdditional')
    && routering_res.result && (routering_res.result == "ok") &&
    routering_res.res_data.router_backup_available);
   }
   $scope.menuItems = [
    {
     image: WTG.img("settings_icon.svg"),
     title:$rootScope.strings.result_list_settings,
     show:true,
     disable:C11N.is_portal,
     onClick:  function(){
      async.parallel({
       turned_off :TUTIL.get_turned_off.bind(null,message.testname)
      },function(e,r) {
       if(e)  L.error({err:e},"error getting tests turned off status");
       L.trace("test_card_settings_ctrl--r--"+JSON.stringify(r));
       if(r.turned_off)  obj.turned_off = r.turned_off;
       H2GDIALOG.create_customDialog(H2GDIALOG.test_card_settings_ctrl,obj,"");
      });
      $scope.cancel();
     }
    },
    {
     image: WTG.img("history_icon.svg"),
     title: $rootScope.strings.result_list_history,
     show:true,
     disable:false,
     onClick: function(){
      $scope.cancel();
      H2GHISTORY.showTestHistory(message);
     }
    },
    {
     image: WTG.img("expand_more_icon.svg"),
     title:$rootScope.strings.result_list_details,
     show:message.more,
     disable:false,
     onClick: function(){$scope.cancel();H2GDIALOG.showInputTemplate(H2GDIALOG.moreDetailsCtrl,obj)}
    },
    {
     image: WTG.img("info.svg"),
     title:$rootScope.strings.result_list_about,
     show:!(_TDC && (!message.about || message.about=="")),
     disable:C11N.is_portal,
     onClick:  function(){$scope.onClickAbout(message.Result_header,message.about)}
    },
    {
     image: WTG.img("backup_icon.svg"),
     title:$rootScope.strings.backup_router_config,
     show:show_backup_restore(),
     disable:C11N.is_portal,
     onClick: function(){
      applyFix(message.Result_header,message.testname,getRouteringTestResults().test_id,"router_backup_restore",{"fix":"backup"},$rootScope.strings.apply_fix_busy_state_dialog_header_title);
      $scope.cancel();
     }
    },
    {
     image: WTG.img("restore_icon.svg"),
     title:$rootScope.strings.restore_router_config,
     show:show_backup_restore(),
     disable:C11N.is_portal,
     onClick: function(){
      if(is_backup_present()) {
       applyFix(message.Result_header,message.testname,getRouteringTestResults().test_id,"router_backup_restore",{"fix":"restore"},$rootScope.strings.apply_fix_busy_state_dialog_header_title);
      }
      else {
       H2GDIALOG.showInputTemplate(H2GDIALOG.popupCtrl,
           {"header" : $rootScope.strings.restore_router_config,"status" : $rootScope.strings.backup_not_available});
      }
      $scope.cancel();
     }
    },
   ];
   $scope.onClickAbout = function(testTitle,about_text){
    L.trace("onClickAbout");
    $scope.cancel();
    ShowScreen("#/app/HelpMe");
    var obj={};
    obj.testTitle=testTitle;
    obj.helpTxt=about_text;
    obj.helpBtn = false;
    obj.scTitle = $rootScope.strings.about_dialog_header+" - "+testTitle;
    setTimeout(function(){ $rootScope.sendHelpMeInfo(obj)},100);
    sendAnalyticsInfo({id:software_use_events.about_test,details:testTitle});
   };
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $rootScope.hide = $mdDialog.cancel.bind($mdDialog);
   if(!C11N.is_portal){
    TUTIL.getTestNotificationSetting(message.testname,"show_notifications",function(e,r) {
     if(e) L.error({err:e},"Error at getTestNotificationSetting");
     else {
      obj.notification_switch_status = r;
     }
    });
   }
  },
  test_card_settings_ctrl : function test_card_settings_ctrl($scope, $mdDialog,$rootScope,message){
   L.trace("message-"+JSON.stringify(message));
   $scope.controller = "showMoreInfoDialog";
   $scope.loaderImg = WTG.img("loader.svg");
   $scope.is_portal = C11N.is_portal;
   $scope.showBusyIcon = false;
   var showSettings = getTestSettingsValue(message.testName);
   L.trace("show settings--"+JSON.stringify(showSettings));
   var is_periodic = is_periodic_test(message.testName);
   var turn_off_test =  message.turned_off;
   $scope.menuItems = [
    {
     image: WTG.img("disabled_icon.svg"),
     title: $rootScope.strings.result_list_ignore,
     id:"ignore_switch",
     show:true,
     disable:C11N.is_portal,
     showSwitch:true,
     switchStatus:false,
     testName:message.testName,
     busyIcon:false,
     onChange: function(item){
      var ignore_status = item.switchStatus? 1:0;
      TR.changeIgnoredStatus(message.testName,message.component,ignore_status);
      TR.re_evaluate(TR.rsh.comp);
      TUTIL.set_ignored(message.testName,item.switchStatus);
     }
    },
    {
     image: WTG.img("disabled_icon.svg"),
     title: $rootScope.strings.settings_turn_off,
     id:"turn_off_switch",
     show:true,
     disable:C11N.is_portal,
     showSwitch:true,
     switchStatus:turn_off_test,
     testName:message.testName,
     busyIcon:false,
     onChange: function(item){
      var dependent_tests = getDependentTests(message.testName);
       if(item.switchStatus){
         if(dependent_tests) {
           H2GDIALOG.enable_or_disable_turn_off_ctrl($scope,"turn_off_switch",false);
           L.trace(message.testTitle+"--dependent_tests--"+dependent_tests);
           var t =  WTG.fmt($rootScope.strings.turn_off_dependent_tests_warning,{"test_name":message.testTitle,"dependent_tests":dependent_tests});
           H2GDIALOG.showInputTemplate(H2GDIALOG.warning_ctrl,
            {
            "header" : "Warning",
            "status" : t,
            "multiple" : true,
             cb:function(){
              L.trace("warning_ctrl callback");
              H2GDIALOG.enable_or_disable_turn_off_ctrl($scope,"turn_off_switch",true);
              store_and_refresh_data(message.testName,message.component,item.switchStatus);
            }});
         }
         else{
          store_and_refresh_data(message.testName,message.component,item.switchStatus);
         }
       }
       else{
        NativeAPI.deleteData("user_settings.tests."+item.testName,"turn_off");
        store_and_refresh_data(message.testName,message.component,item.switchStatus);
       }
       function store_and_refresh_data(tn,comp,switchStatus){
        L.trace("store_and_refresh_data");
        TR.change_Turned_off_status(tn,comp,switchStatus);
        TUTIL.set_turned_off(tn,switchStatus);
        sendAnalyticsInfo({id:software_use_events.test_settings_changed,details:JSON.stringify({test:tn,setting:"turn_off_test",old:!switchStatus,'new':switchStatus})});
        TR.re_evaluate(TR.rsh.comp);
       }
     }
    },
    {
     id:"notifications",
     image: WTG.img("notifications_icon.svg"),
     title: $rootScope.strings.settings_notifications_desc,
     show:true,
     disable:C11N.is_portal,
     showSwitch:true,
     switchStatus:message.notification_switch_status,
     busyIcon:true,
     testName:message.testName,
     onChange: function(item){
      SUTIL.setSetting("tests."+item.testName,"show_notifications",item.switchStatus);
      // TODO: avoid this hardcoded checks.
      // XXX: "LocalScan Notifier" test is not visible, but this is the one handles LocalScan notifications.
      // So i need to change settings for this test automatically when user changes settings for visible test "LocalScan"
      // I think we must have a mechanism(probably in tests.json) to know inter linked/dependent tests. so that we can avoid hard codes.
      if(item.testName=="LocalScan") SUTIL.setSetting("tests.LocalScan Notifier","show_notifications",item.switchStatus);
      //$scope.cancel(); //don't close popup. let user see the change
      sendAnalyticsInfo({id:software_use_events.test_settings_changed,details:JSON.stringify({test:item.testName,setting:"show_notifications",old:!item.switchStatus,'new':item.switchStatus})});
     }
    },
    {
     image: WTG.img("settings_icon.svg"),
     title:showSettings.title,
     show:showSettings.bShow,
     disable:C11N.is_portal,
     onClick:  function(){
      $scope.showSettingScreen(message);
      $scope.cancel();
     }
    },
    {
     image: WTG.img("settings_icon.svg"),
     title: $rootScope.strings.settings_set_interval,
     show:is_periodic,
     disable:C11N.is_portal,
     onClick:  function(){
      //L.trace("showSetIntervalSettingScreen--"+JSON.stringify(message));
      async.parallel({
       poll_interval: SUTIL.getPollInterval.bind(null,"tests."+message.testName,"poll_interval",60),
       poll_interval_screen_off: SUTIL.getPollInterval.bind(null,"tests."+message.testName,"poll_interval_screen_off",180),
      },function(e,r) {
         if(e){
          L.error({err:e},"error getting test poll intervals");
         }
         L.trace("setIntervalCtrl--r--"+JSON.stringify(r));
         if(r.poll_interval && r.poll_interval_screen_off) {
          $rootScope.MultiCtrlDialog(H2GDIALOG.setIntervalCtrl,{test:message,data:r} );
         }
      });
      $scope.cancel();
     }
    }
   ];
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $rootScope.hide = $mdDialog.cancel.bind($mdDialog);
   $scope.showSettingScreen = function(test) {
    for(var item in ui_settings){
     if(test.testName == item){
      H2GDIALOG.showInputTemplate(H2GDIALOG.testSettingsCtrl,test );
      break;
     }
    }
   };
  },
  menuCtrl : function  menuCtrl($scope, $mdDialog,$rootScope,message){
   $scope.controller = "showMoreInfoDialog";
   $scope.loaderImg = WTG.img("loader.svg");
   var obj={};
   obj.moreDetails = get_json_as_html(JSON.parse(message.history.result_data),message.test);
   obj.testTitle=message.history.title;
   $scope.menuItems = [{
    image: WTG.img("expand_more_icon.svg"),
    title:$rootScope.strings.result_list_details,
    show:true,
    onClick: function(){$scope.cancel();H2GDIALOG.showInputTemplate(H2GDIALOG.moreDetailsCtrl,obj)}
   }];
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $rootScope.hide = $mdDialog.cancel.bind($mdDialog);
  },
  moreDetailsCtrl : function moreDetailsCtrl($scope, $mdDialog, $rootScope,$timeout,message) {
   $scope.template_header =  message.testTitle+"  -  "+$rootScope.strings.result_list_details;
   $scope.template_body = message.moreDetails;
   $scope.hide_btn_two = !(message.testName && (message.testName=="routering") && ui_settings && ui_settings[message.testName].get_logs_btn && (ui_settings[message.testName].get_logs_fun!=""));
   $scope.action_btn_one = $rootScope.strings.get_logs_btn;
   $scope.action_btn_two = $rootScope.strings.ok_btn;
   $scope.is_portal = C11N.is_portal;
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.hide = function() {
    $mdDialog.hide();
    applyFix(message.testTitle,message.testName,message.testId,ui_settings[message.testName].get_logs_fun,"","");
   };
   $scope.setValue = function(answer) {$mdDialog.hide(answer)};
   sendAnalyticsInfo({id:software_use_events.test_details,details:message.testTitle});
  },
  popupCtrl : function popupCtrl($scope, $mdDialog,$rootScope,$timeout,message) {
   $scope.hed_icon = false;
   $scope.template_header = message.header;
   $scope.is_portal = C11N.is_portal;
   $scope.template_body =  "<p>"+ message.status+"</p>";
   $scope.hide_btn_two = true;
   $scope.action_btn_two = $rootScope.strings.ok_btn;
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.hide = $mdDialog.hide.bind($mdDialog);
   $scope.setValue = function(answer) {$mdDialog.hide(answer)};
  },
  gen_popup : function gen_popup($scope, $mdDialog, $rootScope, $timeout, message) {
   $scope.is_portal = C11N.is_portal;
   $scope.hed_icon = false;
   $scope.template_header = message.header;
   $scope.template_body = message.body;
   $scope.action_btn_two = message.btn_one;
   $scope.hide_btn_two = !message.btn_two;
   $scope.hide_btn_three = !message.btn_three;
   $scope.action_btn_one = message.btn_two;
   $scope.action_btn_three = message.btn_three;
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.hide = function() {
    $mdDialog.hide();
    L.trace("btn two");
    if(message.cb_two) message.cb_two(message.btn_two,message.rid);
   };
   $scope.setValue = function(/*answer*/) {
     $mdDialog.hide();
     L.trace("btn one");
     if(message.cb_one) message.cb_one(message.btn_one,message.rid);
   };
   $scope.btn_three_click = function() {
    $mdDialog.hide();
    L.trace("btn three");
    if(message.cb_three) message.cb_three(message.btn_three,message.rid);
   };
  },
  testSettingsCtrl : function testSettingsCtrl($scope, $mdDialog,$rootScope,$timeout,message){
   var testName=message.testname;
   var testTitle=message.Result_header;
   //L.trace('testSettingsCtrl--Name=='+testName+'title=='+testTitle);
   var _us = ui_settings[testName];
   var sPath  =  _us.storagepath || "";
   var sRes  =  _us.res || "";
   var defVal =  _us.defvalue || 0;
   $scope.settingsValue = defVal ;
   function setTestResultScreenSettings(val) {
    $scope.settingsValue = val;
    $scope.old = val;
   }
   $scope.hed_icon = true;
   $scope.icon_src = WTG.img("settings_icon.svg");
   $scope.template_header = testTitle ;
   $scope.template_body = $rootScope.strings[_us.desc] ||  "" ;
   $scope.input_postfix = $rootScope.strings[_us.units] || "ms";
   $scope.min_val = _us.min || "0";
   $scope.max_val = _us.max || "100";
   $scope.controller =  _us.control || "";
   SUTIL.getSetting(sPath,sRes,defVal,function(err,val){
    if(err) return L.error("getTestResultScreenSettings-error-"+err);
    setTestResultScreenSettings(val);
   });
   $scope.action_btn_one = $rootScope.strings[_us.btn1];
   $scope.action_btn_two = $rootScope.strings[_us.btn2];
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.hide = $mdDialog.hide.bind($mdDialog);
   $scope.setValue = function(answer) {
    $mdDialog.hide(answer);
    L.trace("testSettingsCtrl--setValue=="+answer);
    SUTIL.setSetting(sPath,sRes,parseInt(answer));
    sendAnalyticsInfo({id:software_use_events.test_settings_changed,details:JSON.stringify({test:message.testName,setting:sPath,old:$scope.old,'new':$scope.settingsValue})});
   };
   $scope.getPostfix = function(time){
    return time +" "+$rootScope.strings.settings_time_unit_milliseconds_short;
   };
  },
  setIntervalCtrl : function setIntervalCtrl($scope, $mdDialog,$rootScope,$timeout,message) {
   var tn  = message.test.testName;
   $scope.template_header =message.test.testTitle;
   $scope.settingsValue = {"poll_interval": message.data.poll_interval,"poll_interval_screen_off":  message.data.poll_interval_screen_off };
   $scope.controllers = [{id:"poll_interval", header:$rootScope.strings.settings_cpu_usage_screen_on_slider_header,ctrl : "showSlider",min_val:5,max_val:120},{id:"poll_interval_screen_off", header:$rootScope.strings.settings_cpu_usage_screen_off_slider_header,ctrl : "showSlider",min_val:120,max_val:600}] ;
   $scope.step =  1 ;
   $scope.action_btn_one =$rootScope.strings.cancel_btn;
   $scope.action_btn_two =$rootScope.strings.set_btn;
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.hide = $mdDialog.hide.bind($mdDialog);
   $scope.setValue = function(test_intrvls) {
    SUTIL.setSetting("tests."+tn,"poll_interval",parseInt(test_intrvls.poll_interval));
    SUTIL.setSetting("tests."+tn,"poll_interval_screen_off",parseInt(test_intrvls.poll_interval_screen_off));
    NativeAPI.notify_settings_change("poll_interval",tn);
    $mdDialog.hide(test_intrvls);
   };
   $scope.getPostfix = function(time){
       if(_TDC) return (time+" "+ $rootScope.strings.settings_time_unit_min);
       return covertSecondsToMinsSecs(time);
   };
  },
  showBusyState : function showBusyScreen(header,desc,cancel,cb,testName){
   if(!C11N.is_portal) {
    var rscope = angular.element($('#appScreensContainer')).scope();
    if(rscope)rscope.showBusyScreen(header,desc,cancel,cb,testName);
   }
  },
  /* TODO: providing callback in the interface and never calling back is
   * particularly bad. */
  hideBusyState : function hideBusyScreen(/*header,desc,cancel,cb,testName*/){
   if(!C11N.is_portal) {
    var rscope = angular.element($('#appScreensContainer')).scope();
    if(rscope)rscope.hideBusyScreen();
   }
  },
  router_cred_overlay_ctrl : function router_cred_overlay_ctrl($scope, $mdDialog, $rootScope,$timeout,message) {
   L.trace("message - "+JSON.stringify(message));
   $scope.gen_overlay_screen = 'router_cred_overlay';
   $scope.header=$rootScope.strings.router_dialog_content;
   $scope.userName=$rootScope.strings.router_dialog_username;
   $scope.password = $rootScope.strings.router_dialog_pwd;
   $scope.userNameR = $rootScope.strings.router_dialog_validation_username_required;
   $scope.passwordR = $rootScope.strings.router_dialog_validation_pwd_required;
   $scope.cancel_str = $rootScope.strings.cancel_btn;
   $scope.ok = $rootScope.strings.ok_btn;
   $scope.is_portal = C11N.is_portal;
   $scope.show_warn_msg = !!message.errCode;
   $scope.warn_msg=message.msg||"";
   $scope.cancel = $mdDialog.cancel.bind($mdDialog);
   $scope.un_field=false;
   $scope.pw_field=false;
   $scope.hide_user_name_field=!message.show_user_name_field;
   $scope.u_name = message.un;
   $scope.p_word = message.pw;
   $scope.cancelBtnClick = function() {
    $scope.cancel();
   };
   $scope.okBtnClick = function(username,password){
    if(message && password) setTimeout(function() {
     if(message.reqId) request_completed(message.reqId,JSON.stringify({un:username,pw:password}));
     else applyFix(message.td.title,message.td.tn,message.td.testid,message.td.fix,message.td.rd,$rootScope.strings.apply_fix_busy_state_dialog_header_title,username,password);
     $scope.cancel();
    }, 0);
    else{
     $scope.un_field= !username;
     $scope.pw_field= !password;
     $scope.cancel();
    }
   };
  },
  generic_info_ctrl:function($scope, $mdDialog, $rootScope,$timeout,message) {
   $scope.gen_overlay_screen = 'generic_info_overlay';
   $scope.is_portal = C11N.is_portal;
   $scope.header = message.title;
   $scope.details = message.desc;
   $scope.logPath = message.r;
   $scope.ok = message.btn;
   $scope.btnClick = function(){$mdDialog.hide()};
  },
  enable_or_disable_turn_off_ctrl : function enable_or_disable_turn_off_ctrl($scope,id,switch_val){
   if(!$scope.menuItems || !$scope.menuItems.length) return;
   $scope.menuItems.forEach(function(y){if(y.id && (y.id == id)){y.switchStatus = switch_val}});
   setTimeout(function() {$scope.$apply() }, 0);
  }
 };

export default H2GDIALOG;
